export const keyLocalStorage = {
  USER_STORAGE: "authenticateuser",
  DEFAULT_CONSTANTS: "default_constants",
  /** Preferências do Configurator: tema e tipo do menu lateral */
  UI_LAYOUT_PREFERENCES: "tnv_ui_layout_preferences",
} as const;

export const coordDefault = {
  latitude: -20.270352735690643,
  longitude: -50.55598455935551,
};

export type ItemOption = { label: string; value: string };

export const UNIDADEDISTANCIA = ["Metros", "KM", "Milhas"];

export const TAM_QTD_CAMISETA_DEFAULT = [
  { tamanho: "P", qtd: 100 },
  { tamanho: "M", qtd: 100 },
  { tamanho: "G", qtd: 100 },
  { tamanho: "GG", qtd: 100 },
];

export const OPTIONTIPOINSCRICAO: ItemOption[] = [
  { label: "Individual", value: "0" },
  { label: "Dupla", value: "2" },
  { label: "Trio", value: "3" },
  { label: "Quádruplo", value: "4" },
  { label: "Quintuplo", value: "5" },
];

export const OPTIONEXIBIRINSCRITO: ItemOption[] = [
  { label: "Sempre Exibir", value: "allowed" }, // permite a exibitação a todo momento a lista de inscrito
  { label: "Nunca Exibir", value: "not_allowed" }, // permite a exibição após encerrar as inscrições
  { label: "Após encerramento inscrição", value: "only_after_closing" }, // não permite a exibição dos inscritos
];

export const colorsCupons = [
  "#F96030",
  "#00A53C",
  "#3C0050",
  "#004250",
  "#F93030",
  "#4C50B7",
  "#522F50",
  "#04700F",
  "#851212",
] as const;

export const SEXO_VALUES = {
  "Masc/Fem": 1,
  Masculino: 2,
  Feminino: 3,
};
